module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForWin_pic8.4f2e4c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForWin/dataLeakInstallForWin_pic8.png
// module id = 499
// module chunks = 1